export class FilterWithDropdownChipsController {
    static $inject = ['$rootScope'];
    constructor($rootScope) {
        'ngInject';
        this.$rootScope = $rootScope;
        this.optionSelect = [];
        this.items = [];
        this.hiddennessItem = 5;
        this.applyFilter = () => {
            this.$rootScope.$broadcast('ToggleDropdownItem');
            this.$rootScope.$broadcast('angucomplete-alt:clearInput');
            this.items = this.optionSelect;
            this.handleFilter({ $items: this.items });
        };
        this.removeItem = (event) => {
            const { id } = event.detail;
            this.items = this.items.filter(item => item !== id);
            this.optionSelect = this.items;
            this.handleFilter({ $items: this.items });
        };
        this.onChangeItem = (event) => {
            const { detail: { data } } = event;
            this.optionSelect = data;
        };
        this.clearFilter = () => {
            this.optionSelect = [];
            if (this.items.length > 0) {
                this.items = [];
                this.handleFilter({ $items: this.items });
            }
        };
        this.getItemName = () => {
            return this.items.slice(this.hiddennessItem).join(',\r\n');
        };
    }
}
FilterWithDropdownChipsController.$inject = ['$rootScope'];
